'use client'

import React, { useState, createContext, useEffect, ReactNode } from 'react'

interface SectionThemeContextType {
  selectedColorScheme: string
  setSelectedColorScheme: (colorScheme: string) => void
}

interface SectionThemeProviderProps {
  children: ReactNode
  colorScheme?: string
}

export const SectionThemeContext = createContext<SectionThemeContextType>({
  selectedColorScheme: 'darkGreen',
  setSelectedColorScheme: () => null,
})

const SectionThemeProvider = ({ children, colorScheme = 'green' }: SectionThemeProviderProps) => {
  const [selectedColorScheme, setSelectedColorScheme] = useState<string>(colorScheme)

  useEffect(() => {
    setSelectedColorScheme(colorScheme)
  }, [])

  return (
    <SectionThemeContext.Provider
      value={{ selectedColorScheme, setSelectedColorScheme }}
    >
      {children}
    </SectionThemeContext.Provider>
  )
}

export default SectionThemeProvider
